module.exports = __webpack_public_path__ + "img/herb-mint-190x100.c3193a37.jpg";